import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactGA from "react-ga";
import { useEffect } from "react";
import { CssBaseline } from "@mui/material";
import DocsHome from "./components/docs/DocsHome";
import Introduction from "./components/docs/Introduction";
import Customer from "./components/docs/Customer";
import CreateDemand from "./components/docs/CreateDemand";
import UpdateDemand from "./components/docs/UpdateDemand";
import InvoiceAction from "./components/docs/InvoiceAction";
import PendingDemandsVendors from "./components/docs/office/PendingDemandsVendors";
import PendingStatements from "./components/docs/office/PendingStatements";
import ApproveStatement from "./components/docs/office/ApproveStatements";

const TRACKING_ID = "UA-232391990-2";
ReactGA.initialize(TRACKING_ID);
function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <BrowserRouter>
      <CssBaseline enableColorScheme />
      <Routes>
        <Route
          path="/"
          element={
            <DocsHome>
              <Introduction />
            </DocsHome>
          }
        />
        <Route
          path="/introduction"
          element={
            <DocsHome>
              <Introduction />
            </DocsHome>
          }
        />
        <Route
          path="/customer"
          element={
            <DocsHome>
              <Customer />
            </DocsHome>
          }
        />
        <Route
          path="/demand/create"
          element={
            <DocsHome>
              <CreateDemand />
            </DocsHome>
          }
        />
        <Route
          path="/demand/update"
          element={
            <DocsHome>
              <UpdateDemand />
            </DocsHome>
          }
        />
        <Route
          path="/invoice-action"
          element={
            <DocsHome>
              <InvoiceAction />
            </DocsHome>
          }
        />
        <Route
          path="/office/pending-demands-vendors"
          element={
            <DocsHome>
              <PendingDemandsVendors />
            </DocsHome>
          }
        />
        <Route
          path="/office/pending-statements"
          element={
            <DocsHome>
              <PendingStatements />
            </DocsHome>
          }
        />
        <Route
          path="/office/approve-statement"
          element={
            <DocsHome>
              <ApproveStatement />
            </DocsHome>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
